import axios from './axiosService';

/**
 * MLD-5472
 */
export default {
  getTerritory(territoryID) {
    return axios.get(`/api/territories/${territoryID}`)
      .then(response => response.data);
  },
  getTerritories() {
    return axios.get(`/api/territories`)
      .then(response => response.data);
  },
  deleteTerritory(territoryID) {
    return axios.delete(`/api/territories/${territoryID}`)
      .then(response => response.data);
  }
}
